const SearchField = ({ value, onChange, placeholder }) => {
    return (
      <div className="input-group mb-3">
        <span className="input-group-text">
          <i className="fas fa-search"></i>
        </span>
        <input
          type="text"
          className="form-control"
          placeholder={placeholder || "Buscar..."}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    );
  };

  export default SearchField; 